const DEFAULT_TXN_CUTOVER_ISO = '2026-02-10T00:00:00Z';

export const getTransactionCutoverDate = () => {
  const raw = process.env.REACT_APP_TXN_CUTOVER_DATE || DEFAULT_TXN_CUTOVER_ISO;
  const parsed = new Date(raw);

  if (Number.isNaN(parsed.getTime())) {
    return new Date(DEFAULT_TXN_CUTOVER_ISO);
  }

  return parsed;
};

export const getTransactionCreatedAt = tx => {
  const createdAt = tx?.attributes?.createdAt;
  if (createdAt) {
    const parsed = new Date(createdAt);
    if (!Number.isNaN(parsed.getTime())) {
      return parsed;
    }
  }

  const transitions = tx?.attributes?.transitions;
  if (Array.isArray(transitions) && transitions.length > 0) {
    const earliest = transitions.reduce((result, transition) => {
      const ts = transition?.createdAt ? new Date(transition.createdAt) : null;
      if (!ts || Number.isNaN(ts.getTime())) {
        return result;
      }

      if (!result || ts < result) {
        return ts;
      }

      return result;
    }, null);

    if (earliest) {
      return earliest;
    }
  }

  return null;
};

export const isLegacyTransaction = (tx, cutoverDate = getTransactionCutoverDate()) => {
  const createdAt = getTransactionCreatedAt(tx);
  if (!createdAt) {
    return false;
  }

  return createdAt < cutoverDate;
};

export const DEFAULT_TXN_CUTOVER_DATE = DEFAULT_TXN_CUTOVER_ISO;

export default {
  getTransactionCutoverDate,
  getTransactionCreatedAt,
  isLegacyTransaction,
  DEFAULT_TXN_CUTOVER_DATE,
};
